import * as React from 'react';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import Container from '@mui/material/Container';

function ResponsiveAppBar() {
  return (
    <AppBar position="static" sx={{backgroundColor:'#ebf1f4', height: 20+"%", marginBottom: 2+"%"}}>
      <Container maxWidth="xl">
        <Toolbar disableGutters>
          <img src='./iDEAL_Wero_Lockup_Yellow_Horizontal_RGB.svg' style={{width:10+"%", height:10+"%"}}></img>
        </Toolbar>
      </Container>
    </AppBar>
  );
}
export default ResponsiveAppBar;








